import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-10" }) => (
  <img
    src="/logo.png"
    alt="Oregon Tote Rentals logo"
    className={`w-auto object-contain ${className}`}
  />
);

export const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="nav-logo" className="flex items-center">
    <img
      src="/logo.png"
      alt="Oregon Tote Rentals"
      className={`h-20 w-auto object-contain ${dark ? "rounded-lg bg-white px-2 py-1" : ""}`}
    />
  </Link>
);
